import { FormInput, Loader } from "@/components";
import { Button } from "@/components/ui";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui";
import { FormProvider } from "react-hook-form";
import useForgotPassword from "./useForgotPassword";
import coverImg from "@/assets/loginCover.svg";
import { EMAIL_ID } from "./consts";

const ForgotPassword = () => {
  const { form, onSubmit, requiredFields, isForgotPasswordPending } =
  useForgotPassword();
  const { errors } = form.formState;

  return (
    <div className="flex md:flex-row w-full h-[100vh]">
      <div className="hidden md:flex flex-col justify-center items-center w-1/2 bg-blue-900 text-white p-8 relative">
        <div className="absolute inset-0 bg-black bg-opacity-30"></div>
        <img
          src={coverImg}
          alt="Background"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="relative text-center z-10">
          <h1 className="text-[30px] lg:text-[54px] font-bold">
            Welcome to Communacam
          </h1>
        </div>
      </div>
      <div className="w-full md:w-1/2 bg-gray-100 flex flex-col justify-center items-center p-8">
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <Card className="w-full lg:w-[400px]">
              <CardHeader className="my-[20px]">
                <CardTitle className="text-center font-[500] text-[24px]">
                  Forgot Password
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="grid grid-col-1 gap-5">
                  <div>
                    <label className="text-[14px] font-[400]">Email</label>
                    <FormInput
                      name={EMAIL_ID}
                      control={form.control}
                      placeholder="Please enter"
                      error={errors[EMAIL_ID]?.message}
                      isRequired={requiredFields.includes(EMAIL_ID)}
                    />
                  </div>
                </div>
              </CardContent>
              <CardFooter>
                <Button
                  type="submit"
                  className="w-full"
                  disabled={isForgotPasswordPending}
                >
                  {isForgotPasswordPending ? (
                    <Loader variant="secondary" />
                  ) : (
                    ""
                  )}{" "}
                  Send Email
                </Button>
              </CardFooter>
            </Card>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default ForgotPassword;
